import React, { forwardRef } from 'react';
import { ChevronDown } from 'lucide-react';

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  error?: boolean;
  success?: boolean;
  options: { value: string; label: string }[];
}

const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ error, success, options, className = '', ...props }, ref) => {
    const baseClasses = `
      w-full max-w-xs px-4 py-2 border rounded-full font-medium text-slate-900 
      bg-white transition-all duration-200 appearance-none
      focus:outline-none focus:ring-2 focus:ring-offset-0 pr-12
      shadow-sm
    `;

    const stateClasses = error
      ? 'border-red-300 focus:border-red-500 focus:ring-red-500/20 focus:bg-white'
      : success
        ? 'border-green-300 focus:border-green-500 focus:ring-green-500/20 focus:bg-white'
        : 'border-slate-300 focus:border-blue-500 focus:ring-blue-500/20 focus:bg-white hover:border-slate-400';

    return (
      <div className='relative flex items-center gap-2'>
        <select
          ref={ref}
          className={`${baseClasses} ${stateClasses} ${className}`}
          {...props}
        >
          {options.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <div className='absolute inset-y-0 right-3 flex items-center pointer-events-none bg-transparent'>
          <ChevronDown className='h-4 w-4 text-slate-400' />
        </div>
      </div>
    );
  }
);

Select.displayName = 'Select';

export default Select;
